<template>
    <div>
<!--        Whatsapp broadcast "<strong>{{ $_.get(activity, "payload.title") }} </strong>" was failed.-->
        <span v-html="$t('notification.whatsappBroadcastFailed', {title: $_.get(activity, 'payload.title') })"></span>

    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WhatsappBroadcastFailed",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
